import React from "react";
import { Empty } from "antd";
import NoItems from "./noitems.svg";

const PsNoData = (props) => {
  const minHeight = {
    height: "calc(100vh - 200px)",
  };
  return (
    <>
      <center
        className="py-3 d-flex align-items-center justify-content-center"
        style={props.withHeight && minHeight}
      >
        <Empty description={props.description || "No data"} image={NoItems} />
      </center>
    </>
  );
};
export default PsNoData;
